// 게임 화면의 알림 배너를 "기준 모양(템플릿)"과 비교하는 도구(순수 JS, OpenCV 없음).
// 밝기만 쓰는 정규화 상호상관(NCC)이라 배경 밝기/대비가 달라도 모양이 같으면 높은 점수가 나온다(−1~1).

// RGBA 이미지 → 가로세로 절반 크기의 밝기(0~255) 이미지. 2×2 평균이라 계산량이 4분의 1이고 압축 잡음에도 덜 민감하다.
export function toHalfGray(image) {
  const width = Math.floor(image.width / 2);
  const height = Math.floor(image.height / 2);
  const data = new Uint8Array(width * height);
  for (let y = 0; y < height; y += 1) {
    for (let x = 0; x < width; x += 1) {
      let sum = 0;
      for (let dy = 0; dy < 2; dy += 1) {
        for (let dx = 0; dx < 2; dx += 1) {
          const i = ((y * 2 + dy) * image.width + (x * 2 + dx)) * 4;
          sum += 0.299 * image.data[i] + 0.587 * image.data[i + 1] + 0.114 * image.data[i + 2];
        }
      }
      data[y * width + x] = Math.round(sum / 4);
    }
  }
  return { width, height, data };
}

/**
 * gray(절반 크기 밝기 이미지)에서 template(밝기 이미지, 기준 위치 template.x/y)을 기준 위치 ±range 픽셀 안에서 찾아
 * 가장 높은 NCC 점수를 돌려준다. 이미지 밖으로 나가는 위치는 건너뛴다.
 */
export function matchTemplate(gray, template, range = 6) {
  const { width: tw, height: th, data: t } = template;
  const n = tw * th;
  let tMean = 0;
  for (let i = 0; i < n; i += 1) {
    tMean += t[i];
  }
  tMean /= n;
  let tVar = 0;
  for (let i = 0; i < n; i += 1) {
    tVar += (t[i] - tMean) ** 2;
  }
  const tNorm = Math.sqrt(tVar);
  if (tNorm === 0) {
    return -1;
  }

  let best = -1;
  for (let oy = -range; oy <= range; oy += 1) {
    for (let ox = -range; ox <= range; ox += 1) {
      const x0 = template.x + ox;
      const y0 = template.y + oy;
      if (x0 < 0 || y0 < 0 || x0 + tw > gray.width || y0 + th > gray.height) {
        continue; // eslint-disable-line no-continue
      }
      let iMean = 0;
      for (let y = 0; y < th; y += 1) {
        const row = (y0 + y) * gray.width + x0;
        for (let x = 0; x < tw; x += 1) {
          iMean += gray.data[row + x];
        }
      }
      iMean /= n;
      let cross = 0;
      let iVar = 0;
      for (let y = 0; y < th; y += 1) {
        const row = (y0 + y) * gray.width + x0;
        for (let x = 0; x < tw; x += 1) {
          const di = gray.data[row + x] - iMean;
          cross += di * (t[y * tw + x] - tMean);
          iVar += di * di;
        }
      }
      if (iVar > 0) {
        best = Math.max(best, cross / (Math.sqrt(iVar) * tNorm));
      }
    }
  }
  return best;
}
